<template>
  <div
    class="d-flex"
    style="max-height: 100%; overflow: hidden"
  >
    <div
      v-if="streets.preflop_actions?.length"
      class="street-container"
    >
      <div class="street-name">{{ $t('table_head.preflop') }}</div>
      {{ getAction(streets.preflop_actions) }}
    </div>
    <div
      v-if="streets.flop_actions?.length"
      class="street-container"
    >
      <div class="street-name">{{ $t('table_head.flop') }}</div>
      {{ getAction(streets.flop_actions, true) }}
    </div>
    <div
      v-if="streets.turn_actions?.length"
      class="street-container"
    >
      <div class="street-name">{{ $t('table_head.turn') }}</div>
      {{ getAction(streets.turn_actions, true) }}
    </div>
    <div
      v-if="streets.river_actions?.length"
      class="street-container"
    >
      <div class="street-name">{{ $t('table_head.river') }}</div>
      {{ getAction(streets.river_actions, true) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'StreetActionsCompacted',
  props: {
    streets: Object,
  },
  methods: {
    getAction(actions, renameToBet) {
      let res = actions.map(i => i.substring(0, 1)).join(' ')
      if (renameToBet) {
        // res = 'R R'
        res = res.replace('R', 'B')
      }
      return res
    },
  },
}
</script>

<style lang="scss" scoped>
.street-container {
  position: relative;
  padding: 0 1rem 0 0;
  max-height: 2.2rem;
  position: relative;
  letter-spacing: -0.5px;
  font-size: 0.925rem;
  font-weight: 500;
}
.street-name {
  letter-spacing: 0px;
  position: relative;
  display: flex;
  align-items: center;
  // justify-content: center;
  line-height: 1;
  color: var(--clr-grey-2);
  &::first-letter {
    text-transform: capitalize !important;
  }
  font-size: 0.8rem;
  height: 0.7rem;
  // left: -4px;
}
</style>
